// extracted by mini-css-extract-plugin
export default {"menu":"style_menu__hM9Hl","checkIcon":"style_checkIcon__iAVQS","checkbox":"style_checkbox__NOnUw"};